import { useEffect, useState } from "react";
import { ArrowUpRight, Rss } from "lucide-react";
import { api } from "../../lib/api";
import { IMAGES, TerminalImage } from "./TerminalImage";

const formatDate = (raw) => {
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }).toUpperCase();
};

export const NewsFeed = () => {
  const [items, setItems] = useState([]);
  const [state, setState] = useState("loading");

  useEffect(() => {
    api
      .get("/news")
      .then((r) => {
        setItems(r.data.items || []);
        setState(r.data.items && r.data.items.length ? "ready" : "error");
      })
      .catch(() => setState("error"));
  }, []);

  return (
    <section id="terminal-news-feed" className="py-20 border-b border-line bg-navy-alt" data-testid="news-feed-section">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex justify-between items-end mb-8 gap-4 flex-wrap">
          <div>
            <span className="text-xs font-mono text-cy uppercase tracking-widest">[04] PRESS FEED</span>
            <h2 className="font-display text-4xl text-white uppercase mt-2">Industry News &amp; Reports</h2>
          </div>
          <span className="text-xs font-mono text-mut flex items-center gap-2">
            <Rss className="w-3.5 h-3.5 text-cy" /> LIVE SYNDICATED DISPATCHES
          </span>
        </div>

        {state === "loading" && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="news-loading">
            {[0, 1, 2].map((i) => (
              <div key={i} className="p-6 rounded-xl bg-surface border border-line animate-pulse h-40" />
            ))}
          </div>
        )}

        {state === "error" && (
          <div className="p-6 rounded-xl bg-surface border border-line font-mono text-xs text-mut" data-testid="news-error">
            Live press feed is temporarily unavailable.{" "}
            <a
              href="https://news.google.com/search?q=%22private%20credit%22%20Australia"
              target="_blank"
              rel="noopener noreferrer"
              className="text-cy hover:underline"
            >
              Browse coverage on Google News
            </a>
            .
          </div>
        )}

        {state === "ready" && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 font-mono text-xs" data-testid="news-grid">
            {items.map((item, i) => (
              <a
                key={`${item.link}-${i}`}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`news-card-${i}`}
                className="p-6 rounded-xl bg-surface border border-line hover:border-cy/40 transition-colors group flex flex-col"
              >
                <div className="text-cy text-[10px]">
                  {item.source.toUpperCase()}
                  {formatDate(item.published) ? ` \u2022 ${formatDate(item.published)}` : ""}
                </div>
                <h3 className="font-body text-base text-white mt-2 font-semibold leading-snug group-hover:text-cy transition-colors">
                  {item.title}
                </h3>
                <span className="mt-auto pt-4 text-slate-500 inline-flex items-center gap-1 text-[10px]">
                  READ AT SOURCE <ArrowUpRight className="w-3 h-3" />
                </span>
              </a>
            ))}
          </div>
        )}

        <div className="mt-8 rounded-xl border border-line overflow-hidden">
          <TerminalImage
            src={IMAGES.press}
            alt="Financial news wire terminal"
            testId="press-strip-visual"
            className="aspect-[21/4] drift-cyan p-6"
          >
            <div className="text-xs font-mono text-mut mt-auto">
              Press feed indexed from Australian financial media, regulator bulletins, and research papers.
            </div>
          </TerminalImage>
        </div>
      </div>
    </section>
  );
};
